<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  mounted() {
    this.fn();
    window.onresize = this.fn;
  },
  methods: {
    fn() {
      if (document.documentElement.clientWidth > 750) {
        document.documentElement.style.fontSize = 37.5 + "px";
      }
    },
  },
};
</script>
<style lang="less">
#app1 {
  // overflow-x: hidden;
  // background: RGBA(14, 10, 3, 1);
  // min-width: 375px;

}
@media screen and(min-width:751px) {
  #app {
    max-width: 375px;
    margin: 0 auto !important;
  }
}
</style>
